/**
 * Two short beeps through the Web Audio API — no asset to load, and it works
 * where the Vibration API does not (every iPhone).
 */
export function chime() {
  try {
    const context = new (
      window.AudioContext ?? (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext!
    )();
    [0, 0.22].forEach((offset) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = "sine";
      oscillator.frequency.value = 880;
      gain.gain.setValueAtTime(0.0001, context.currentTime + offset);
      gain.gain.exponentialRampToValueAtTime(0.25, context.currentTime + offset + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + offset + 0.16);
      oscillator.connect(gain).connect(context.destination);
      oscillator.start(context.currentTime + offset);
      oscillator.stop(context.currentTime + offset + 0.18);
    });
    setTimeout(() => void context.close(), 800);
  } catch {
    /* audio blocked until the page has been interacted with; the bar still shows */
  }
  navigator.vibrate?.([80, 60, 80]);
}
